import { SingleCommands } from '@tiptap/core';

/**
 * Updates the attributes of the node at the correct depth.
 */
export default function updateNestedAttribute(commands: SingleCommands, nodeType: string, attr: string, value: any) {
  return commands.command(({ tr, state, dispatch }) => {
    if (dispatch) {
      let lastPos = null;

      tr.selection.ranges.forEach((range) => {
        state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos) => {
          if (node.type.name === nodeType) {
            lastPos = pos;
          }
        });
      });

      if (lastPos) {
        tr.setNodeAttribute(lastPos, attr, value);
      }
    }

    return true;
  });
}
